import { Numeric8CircleIcon } from './Numeric8CircleIcon';

/**
 * author: Contributors
 * id 26382400-22B1-40A6-9C1A-46C649C36783
 * name numeric-8-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-8-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const NumberEightCircleIcon = Numeric8CircleIcon;
export default NumberEightCircleIcon